export default "/images/a3da25de421c2d6fe4927222433ec86e.avif";